import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AccountService } from '@infodocs/shared/services/account.service';
import { AuthService } from '@infodocs/shared/services/auth.service';
import { UserLogin } from '@infodocs/shared/interfaces/user';
import { HasObservablesComponent } from '@infodocs/shared/has-observables.component';
import { takeUntil } from 'rxjs';

@Component({
	selector: 'app-public-header-login',
	templateUrl: './public-header-login.component.html',
	styleUrls: ['./public-header-login.component.scss'],
	imports: [
		FormsModule,
		ReactiveFormsModule,
		RouterLink
	]
})
export class PublicHeaderLoginComponent extends HasObservablesComponent {
	protected readonly errors = signal<string[] | undefined>(undefined);
	protected readonly loginForm = new FormGroup({
		email: new FormControl<string>('', [Validators.required, Validators.email]),
		password: new FormControl<string>('', [Validators.required]),
		remember: new FormControl<boolean>(true)
	});

	private readonly auth = inject(AuthService);
	private readonly accountService = inject(AccountService);

	protected submit() {
		this.errors.set(undefined);

		return this.auth.login(this.loginForm.value as UserLogin)
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: result => {
					this.auth.loginAndRedirect(result);

					return this.accountService.fetchAccount();
				},
				error: (err: HttpErrorResponse) => {
					const errorMessage = err.error?.message ||
						(Array.isArray(err.error) ? err.error : ['An unknown error occurred']);
					this.errors.set(Array.isArray(errorMessage) ? errorMessage : [errorMessage]);
				}
			});
	}
}
